import React, { useContext, useState, useEffect } from "react";
import TokenHandle from "../../context/TokenHandle";
import Container from "../../components/Container";

function CardValues() {
  const {
    userData,
    allData,
    invest,
    withdraw,
    reinvestment,
    updateHandle,
    idHandle,
    id,
    solPrice,
    userPlans,
    balanceOf,
    isApprove,
    approveHandle,
    deposit,
    getUserDataDeposit,
  } = useContext(TokenHandle);

  const people = [
    {
      name: "Balance",
      value: userData.balance_,
    },
    {
      name: "Total Investment",
      value: userData.totalDeposits_,
    },
    {
      name: "Total Withdrawals",
      value: userData.totalWithdrawn_,
    },
    {
      name: "Total Ref Rewards",
      value: userData.referrerAmount,
    },
    {
      name: "Referral Bonus",
      value: userData.totalBonus_,
    },
    // More people...
  ];
  return (
    <Container>
        <h1 className="text-slate-900 font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-center mt-8">Dashboard</h1>
      <ul
        role="list"
        className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-8"
      >
        {people.map((person) => (
          <li
            key={person.email}
            className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200"
          >
            <div className="flex-1 flex flex-col p-8">
              <h3 className=" text-xl sm:text-2xl text-slate-900 font-extrabold tracking-tight">
                {person.name}
              </h3>
              <dl className="mt-1 flex-grow flex flex-col justify-between">
                <dt className="sr-only">Title</dt>
                <dd className="text-gray-500 text-sm">{person.value} BUSD</dd>
                <dt className="sr-only">Role</dt>
              </dl>
            </div>
          </li>
        ))}
      </ul>
    </Container>
  );
}

export default CardValues;
